//import { REACT_APP_API_URL } from '@env'
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import * as Application from "expo-application";
import * as Device from "expo-device";
import ErrorToast from "../components/ErrorToast";
import { removeAuth } from "../redux/slices/LoginSlice";
import Constants from "../utils/Constants";
import { isWeb } from "../utils/utils";

const logout = () => {
	const store = require("../redux/store");

	ErrorToast("Session inactive for too long, please login");
	AsyncStorage.removeItem("auth");
	store.default.dispatch(removeAuth());
};

// const REACT_APP_API_URL = "https://incentivestagingcore.foneworx.co.za";
// console.log(api);

const REACT_APP_API_URL = "https://coreapi.foneworx.co.za/core";
const INC_DOMAIN = Constants.VivoURL;

async function api_comm(type, endpoint, data, session_token) {
	const headers = {
		"Cache-Control": "no-cache",
		Pragma: "no-cache",
		Expires: "0",
		"Inc-Domain": Constants.CIP_BRAND,
		"CIPDevice-Model": Device.modelName,
		"CIPDevice-Platform": Device.osName,
		// "CIPDevice-UUID":,
		"CIPDevice-Version": Device.osVersion,
		"CIPDevice-Manufacturer": Device.manufacturer,
		// "CIPDevice-Serial":,
		"App-Version": Application.nativeApplicationVersion,
	};
	if (
		session_token !== undefined &&
		session_token !== "" &&
		session_token !== null
	) {
		headers["Auth-Token"] =
			// "7e5a892e0d622ea2f46e19dbfa26d31d1dabba5434af4519f07af6b2";
			session_token;
	}

	const axiosClient = axios.create();

	axiosClient.defaults.headers = headers;

	if (
		session_token !== undefined &&
		session_token !== "" &&
		session_token !== null
	) {
		axiosClient
			.post(REACT_APP_API_URL + "/auth/api/v2/login/verify", {
				session_token,
			})
			.then((response) => {
				if (response.data.result === false) {
					logout();
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}

	if (type === "get") {
		return axiosClient
			.get(REACT_APP_API_URL + endpoint)
			.then((response) => response)
			.catch(function (error) {
				if (error.response) {
					console.log(error.response.data.error);

					if (error.response?.data?.error?.toLowerCase().includes("session")) {
						logout();
					}

					return Promise.reject({ ...error.response });
				}
				return Promise.reject(error);
			});
	} else if (type === "post") {
		return axiosClient
			.post(REACT_APP_API_URL + endpoint, data)
			.then((response) => response)
			.catch(function (error) {
				if (error.response) {
					console.log(error.response.data.error);
					if (error.response?.data?.error?.toLowerCase().includes("session")) {
						logout();
					}
					return Promise.reject({ ...error.response });
				}
				return Promise.reject(error);
			});
	} else if (type === "put") {
		return axiosClient
			.put(REACT_APP_API_URL + endpoint, data)
			.then((response) => response)
			.catch(function (error) {
				if (error.response) {
					console.log(error.response?.data?.error);
					if (error.response?.data?.error?.toLowerCase().includes("session")) {
						logout();
					}
					return Promise.reject({ ...error.response });
				}
				return Promise.reject(error);
			});
	}

	return null;
}

export default api_comm;
